type GameCategory = {
  name: string;
  path: string;
};

export type FilterGameCategoriesOptions = {
  excludedPaths?: string[];
  limit?: number;
};

export const DEFAULT_EXCLUDED_GAME_CATEGORY_PATHS = ['wild-unlimited-play', 'on-sale', 'all-games'];

export const filterGameCategories = (
  categories: GameCategory[] = [],
  options: FilterGameCategoriesOptions = {},
): GameCategory[] => {
  const { excludedPaths = DEFAULT_EXCLUDED_GAME_CATEGORY_PATHS, limit = 3 } = options;

  const filteredCategories = categories.filter(
    (category) => !excludedPaths.some((excludedPath) => category.path.includes(excludedPath)),
  );

  return filteredCategories.slice(0, limit);
};
